"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTokenClients = void 0;
var _PublicTokenClient = require("./PublicTokenClient");
var _UserTokenClient = require("./UserTokenClient");
let userTokenClient;
let publicTokenClient;

/**
 * Gets token clients for this package, this keeps client instances to minimal
 */
const getTokenClients = () => {
  userTokenClient ??= new _UserTokenClient.UserTokenClient();
  publicTokenClient ??= new _PublicTokenClient.PublicTokenClient();
  return {
    userTokenClient,
    publicTokenClient
  };
};
exports.getTokenClients = getTokenClients;
//# sourceMappingURL=getTokenClients.js.map